import { Fragment } from "react";

import { Element } from "@craftjs/core";

import { prop, define } from "@/components/builder/utils";

import { FormConsentInputBlock, FormConsentLabelBlock, FormConsentContainerBlock, FormConsentInstructionsTextBlock } from "../../..";
import BasePreview from "../../../base";
import { useFormFieldContext } from "../context";

import { useFormConsentUtilities } from "./hook";

function FormConsentPreview({ ...props }) {
  const { field: { field_component } } = useFormFieldContext()

  useFormConsentUtilities()

  if (field_component === 'checkbox_instructions_text') {
    return <BasePreview {...props}>
      <div>
        <Element is={FormConsentContainerBlock} id={`consent-instructions-container`}>
          <Element is={FormConsentInputBlock} id={`consent-input`} />
          <Element is={FormConsentInstructionsTextBlock} id={`consent-instructions-text`} />
        </Element>
        <Element is={FormConsentLabelBlock} id={`consent-label`} />
      </div>
    </BasePreview>
  }

  return <BasePreview {...props}>
    <div>
      {field_component !== 'text' && <Element is={FormConsentInputBlock} id={`consent-input`} />}
      <Element is={FormConsentLabelBlock} id={`consent-label`} />
    </div>
  </BasePreview>
}

export default define('form-consent', FormConsentPreview, Fragment)
  .shared(prop.share('FormConsent', 'form-consent'))
  .property(prop.predefined.customClass())
  .property(...prop.predefined.borders())
  .property(...prop.predefined.appearance())
  .property(...prop.predefined.typography())
  .build()

